module.exports = "/_next/static/media/f6f3ced54eaaffa9b8bb1d4461bda16e.svg";